import { TranslateLoader } from '@ngx-translate/core';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError, timer } from 'rxjs';
import { retry } from 'rxjs/operators';
import { Injector } from '@angular/core';
import { Router } from '@angular/router';
import { environment } from '../../environments/environment';

export class CustomTranslateLoader implements TranslateLoader {
	private router: Router;

	constructor(
		private httpClient: HttpClient,
		private injector: Injector,
	) {
		this.router = this.injector.get(Router);
	}
	getTranslation(lang: string): Observable<any> {
		return new Observable((observer) => {
			// gruppo funzionale dell'azienda corrente: il backend fa il merge default + override del gruppo
			const cmpGroup = localStorage.getItem('def_company_group') || 'standard';
			const url = environment.base_url_browser + environment.serviceUrl_Login + 'translate/' + lang + '?cmp_group=' + encodeURIComponent(cmpGroup);
			this.httpClient
				.get(url)
				.pipe(
					// Ritenta i blip transitori (rete instabile) prima di arrendersi: 2 tentativi con backoff
					retry({
						count: 2,
						delay: (error: HttpErrorResponse, retryCount: number) => (this.isServerUnreachable(error) ? timer(retryCount * 800) : throwError(() => error)),
					}),
				)
				.subscribe({
					next: (translationData) => {
						observer.next(translationData);
						observer.complete();
					},
					error: (error) => {
						observer.error(error);
						// Mostra la pagina "server non disponibile" SOLO se il server è davvero irraggiungibile.
						// Un 401/403/404/500 significa che il server risponde: non è un down.
						if (this.isServerUnreachable(error)) {
							this.router.navigate(['503']);
						}
					},
				});
		});
	}

	/**
	 * True solo per condizioni che indicano un server effettivamente irraggiungibile:
	 * - status 0: connessione rifiutata / rete assente / CORS
	 * - 502/503/504: gateway/servizio non disponibile
	 */
	private isServerUnreachable(error: HttpErrorResponse): boolean {
		const status = error?.status;
		return status === 0 || status === 502 || status === 503 || status === 504;
	}
}
